export default __webpack_public_path__ + "static/media/gallery_06.3ec5514a.jpg";